(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__emailSignupPlaceholderBound) return;
    window.__emailSignupPlaceholderBound = true;

    // `placeholder` is a single HTML attribute, so a per-breakpoint text cannot be
    // expressed in markup alone. Both values ride on the input as data attributes and
    // this swaps between them. Inputs whose mobile text matches the desktop one carry no
    // data attributes at all, so the common case never enters the loop.
    var mobile = window.matchMedia('(max-width: 749px)');

    function applyPlaceholders() {
      var inputs = document.querySelectorAll('.email-signup__input[data-placeholder-mobile]');

      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        var next = mobile.matches ? input.dataset.placeholderMobile : input.dataset.placeholder;

        if (typeof next === 'string' && input.placeholder !== next) {
          input.placeholder = next;
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyPlaceholders);
    } else {
      applyPlaceholders();
    }

    mobile.addEventListener('change', applyPlaceholders);

    // A re-render in the theme editor ships the server-side (desktop) attribute again.
    document.addEventListener('shopify:section:load', applyPlaceholders);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    /* Flags the moment the mobile filter bar goes from flowing with the page to being pinned, so the
     shadow only shows while it actually floats over the grid.

     There is no CSS-only way to ask this that ships everywhere yet (@container scroll-state(stuck)
     is Chromium-only), so it is an IntersectionObserver on the bar itself — no sentinel node, no
     scroll listener. The trick is the negative rootMargin: pulling the observation box down by the
     bar's own sticky offset plus a pixel means the bar is fully inside it while it is still in flow
     (ratio 1) and clipped the instant it pins (ratio < 1). The rect check rules out the other way to
     lose full visibility, a short page where the bar hangs off the bottom of the viewport.

     The offset comes from the resolved `top` rather than from Liquid, so it already includes the
     header height and the merchant's extra offset, whatever the header settings are. But that number
     is NOT stable at boot: this bundle is deferred and runs before header.js has written
     --header-height onto <body>, so the first read comes back 0, and a rootMargin built from 0 can
     never report the bar as pinned — no callback ever fires, so it cannot correct itself either.
     Hence the MutationObserver on the <body> style attribute: that attribute is literally where
     --header-height lives, so it fires exactly when the number this depends on moves, and the
     observer is rebuilt. The offset guard keeps the other writes to body.style (--header-group-height,
     --transparent-header-offset-boolean) from churning observers for nothing. */
  (() => {
    const STUCK_CLASS = 'facets-bar-stuck';
    const mobile = window.matchMedia('(max-width: 749px)');

    let intersectionObserver = null;
    let observedBar = null;
    let observedOffset = null;
    let frame = null;

    const teardown = () => {
      intersectionObserver?.disconnect();
      intersectionObserver = null;
      observedBar = null;
      observedOffset = null;
      document.body.classList.remove(STUCK_CLASS);
    };

    const sync = () => {
      const bar = document.querySelector('.facets-toggle--stuck-shadow');

      if (!bar || !mobile.matches) {
        teardown();
        return;
      }

      const offset = Math.round(parseFloat(getComputedStyle(bar).top)) || 0;
      if (intersectionObserver && bar === observedBar && offset === observedOffset) return;

      teardown();
      observedBar = bar;
      observedOffset = offset;

      intersectionObserver = new IntersectionObserver(
        ([entry]) => {
          if (!entry) return;
          const stuck = entry.intersectionRatio < 1 && bar.getBoundingClientRect().top <= offset + 1;
          document.body.classList.toggle(STUCK_CLASS, stuck);
        },
        { threshold: [1], rootMargin: `-${offset + 1}px 0px 0px 0px` }
      );

      intersectionObserver.observe(bar);
    };

    const scheduleSync = () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        frame = null;
        sync();
      });
    };

    new MutationObserver(scheduleSync).observe(document.body, {
      attributes: true,
      attributeFilter: ['style'],
    });

    mobile.addEventListener('change', scheduleSync);
    window.addEventListener('load', scheduleSync);
    document.addEventListener('shopify:section:load', scheduleSync);
    document.addEventListener('shopify:section:unload', scheduleSync);

    scheduleSync();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__variantRestockTriggerBound) return;
    window.__variantRestockTriggerBound = true;

    // Whether the Rez app can actually take a back-in-stock request for THIS product.
    // Both triggers (the bell here and the delivery-time CTA) work by clicking the app's own
    // injected button, so when the app does not cover the product there is no button and the
    // click does nothing. The app only injects on out-of-stock variants, so "is the button in
    // the DOM right now" is not a usable test — a bell on copa E has to work while the selected
    // variant is in stock. Instead we read the targeting the app itself publishes in REZ_DATA.
    //
    // Deliberately a POSITIVE-EXCLUSION check: it only reports 'unavailable' when the config
    // proves the product is out of scope, so an unknown or reshaped config leaves the triggers
    // exactly as they were. If the app changes its config shape, this stops hiding rather than
    // hiding wrongly. Stamped on <html> so plain CSS can gate markup that gets re-rendered on
    // every variant change without needing to re-run anything.
    function splitList(value) {
      if (!value) return [];
      return String(value)
        .split(',')
        .map(function (item) {
          return item.trim();
        })
        .filter(Boolean);
    }

    function detectRestockApp() {
      var data = window.REZ_DATA;
      if (!data) return 'unknown';

      if (data.storeData && data.storeData.bis_enabled === false) return 'unavailable';

      var config = data.btnConfig;
      if (!config) return 'unavailable';

      var productId = String((data.current_product && data.current_product.id) || '');
      var tags = data.current_product_tags || [];
      var collections = (data.current_collections || []).map(String);

      if (splitList(config.exclude_product_ids).indexOf(productId) !== -1) return 'unavailable';
      var excludedTags = splitList(config.exclude_tags);
      for (var i = 0; i < excludedTags.length; i++) {
        if (tags.indexOf(excludedTags[i]) !== -1) return 'unavailable';
      }

      var allowedCollections = splitList(config.selected_collection_ids);
      var allowedProducts = splitList(config.selected_product_ids);
      var allowedTags = splitList(config.selected_tags);

      // No allowlist at all means the widget covers the whole catalogue.
      if (!allowedCollections.length && !allowedProducts.length && !allowedTags.length) {
        return 'available';
      }

      for (var c = 0; c < allowedCollections.length; c++) {
        if (collections.indexOf(allowedCollections[c]) !== -1) return 'available';
      }
      if (allowedProducts.indexOf(productId) !== -1) return 'available';
      for (var t = 0; t < allowedTags.length; t++) {
        if (tags.indexOf(allowedTags[t]) !== -1) return 'available';
      }

      return 'unavailable';
    }

    var restockAppState = 'unknown';

    function stampRestockApp() {
      restockAppState = detectRestockApp();
      document.documentElement.dataset.restockApp = restockAppState;

      if (restockAppState === 'unavailable') {
        console.warn(
          '[restock] The back-in-stock app does not cover this product, so its notify triggers are hidden. ' +
            'Add the product to the app widget scope to offer them.'
        );
      }
    }

    stampRestockApp();
    // REZ_DATA comes from an inline app-embed script; if the embed loads after this bundle,
    // give it one more chance before settling.
    if (restockAppState === 'unknown') {
      window.addEventListener('load', stampRestockApp, { once: true });
    }

    // The app injects its notify button asynchronously, and only for out-of-stock variants: on a
    // page that loaded with an in-stock variant selected there is no button at all until the
    // shopper picks a sold-out size. How long it then takes is a race against the section
    // re-render — measured at ~0.5s here but not guaranteed to land before the theme's
    // variant:update — so looking exactly once dropped that first click on the floor and the
    // shopper had to click a second time. Keep looking instead.
    var openPollTimer = null;

    function openAppForm() {
      if (openPollTimer) clearInterval(openPollTimer);

      var attempts = 0;

      function attempt() {
        var appButton = document.querySelector('.rez-stock-notification-button');

        if (appButton) {
          clearInterval(openPollTimer);
          openPollTimer = null;
          appButton.click();
          return true;
        }

        if (++attempts > 60) {
          clearInterval(openPollTimer);
          openPollTimer = null;
        }

        return false;
      }

      if (attempt()) return;
      openPollTimer = setInterval(attempt, 150);
    }

    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      var trigger = event.target.closest('[data-restock-trigger]');
      if (!trigger) return;

      // The trigger sits on the whole option button, so unlike the bell it is not something CSS
      // can hide when the app does not cover this product. Without this the click would select
      // the variant and then wait 1.8s for a form that is never coming.
      if (document.documentElement.dataset.restockApp === 'unavailable') return;

      var label = trigger.closest('label');
      var input = label ? label.querySelector('input[type="radio"]') : null;

      // Already the selected variant: the app button already targets it, open the form now.
      if (!input || input.checked) {
        openAppForm();
        return;
      }

      // Otherwise the native label click selects the variant. Wait for the theme's variant
      // update (section re-render + app re-inject) before opening the form; fall back on a timer.
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        document.removeEventListener('variant:update', finish);
        clearTimeout(fallback);
        // one more tick so the app can (re)inject its button for the new variant
        setTimeout(openAppForm, 250);
      }
      var fallback = setTimeout(finish, 1800);
      document.addEventListener('variant:update', finish);
    });

    // Arriving from the quick-add modal: the restock bell there navigates here with the
    // out-of-stock variant preselected (?variant=) and #rez-notify. Poll for the app to
    // inject its notify button for that variant, then open the form automatically.
    if (window.location.hash === '#rez-notify' && restockAppState !== 'unavailable') {
      openAppForm();

      if (window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
